import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import errorImage from '@/assets/error-image.svg';
import { LogoVertical } from '@/components/logos';
import { Page } from '@/components/ui/page';
import { getUserPortalUrl } from '@/utils/path-utils';

export default function UnauthorizedPage() {
  const dashboardUrl = getUserPortalUrl('/dashboard');

  return (
    <Page className='flex flex-col justify-center items-center'>
      <div className='flex flex-col items-center gap-1 text-center relative'>
        <LogoVertical className='absolute -top-36 left-1/2 -translate-x-1/2 ' />

        <img src={errorImage} alt='Access Forbidden' className='mb-4' />

        <Text as='h1' size={TextSizes.MD} weight={FontWeights.BOLD}>
          No access
        </Text>

        <div className='flex flex-col gap-1'>
          <Text as='p' size={TextSizes.MD} className='text-secondary'>
            You don&apos;t have permission to access this app.
          </Text>
          <Text as='p' size={TextSizes.MD} className='text-secondary'>
            You can see all the apps available to you in the{' '}
            <a
              className='text-brand-secondary underline hover:text-brand-secondary_hover'
              href={dashboardUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              User Hub
            </a>
            .
          </Text>
        </div>
      </div>
    </Page>
  );
}
